export const getRuntimeEnvironment = (
  hostname: string = window.location.hostname,
): "production" | "staging" => {
  if (
    hostname === "iwoca.co.uk" ||
    hostname.endsWith(".iwoca.co.uk") ||
    hostname === "iwoca.de" ||
    hostname.endsWith(".iwoca.de")
  ) {
    return "production";
  }

  return "staging";
};
